import sanityClient  from "@sanity/client";

export default sanityClient({
  projectId: "72jlatwv",
  dataset: "production",
  token:
    "skbNq423KKHO4OrSvTV00JF9wVd8a0RS5UsGwCEXyzG1YvP16UzLUEbhvEOiDGz0gsLuj9wi7u5PcS6oTdrHs2OjYJkmQIIISDfJvsM2Vmjb9sJD7gdcxHjk44Zmn280szM0nfrGb4Q6iAnE6PeRQOFpbG4in9ocySeOonRmHWr6SerR9lSH",
});
